import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ConstElement from '../common/ConstElement';
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class CreateMail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            destination: '',
            destination_id: '',
            type: '',
            title: '',
            content: '',
            first_last_name: '',
            email: '',
        }
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleCreateMail = this.handleCreateMail.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleDestinationChange = this.handleDestinationChange.bind(this);
        this.confirmCreateMail = this.confirmCreateMail.bind(this);
        this.processDestinationName = this.processDestinationName.bind(this);
    }
    
    /**
     * Handle change field
     */
    handleFieldChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }
    
    /**
     * Handle change destination
     */
    handleDestinationChange(event) {
        this.state.destination_id = '';
        this.setState({
            [event.target.name]: event.target.value
        })
    }
    
    /**
     * Handle create point
     */
    handleCreateMail() {
        const dataMail = {
            destination: this.state.destination,
            destination_id: this.state.destination_id,
            type: this.state.type,
            title: this.state.title,
            content: this.state.content,
        };
        axios.post('/api/mails/create', dataMail).then(response => {
            if (response.data.hasOwnProperty('success') && response.data.success) {
                $('#confirmModal').modal('hide');
                this.props.history.push('/mails')
            } else if (response.data.error) {
                toast.error(response.data.message);
            } else {
                Object.keys(response.data.errors).map((key, i) => {
                    if($.isArray(response.data.errors[key])){
                        response.data.errors[key].map((child, i) => {
                            toast.error(child)
                        })
                    } else {
                        toast.error(response.data.errors[key])
                    }
                })
            }
        }).catch(error => {
            Object.keys(error.response.data.errors).map((key, i) => {
                if($.isArray(error.response.data.errors[key])){
                    error.response.data.errors[key].map((child, i) => {
                        toast.error(child)
                    })
                } else {
                    toast.error(error.response.data.errors[key])
                }
            })
        })
    }
    
    /**
     * Popup confirm create mail
     */
    confirmCreateMail() {
        const dataMail = {
            destination: this.state.destination,
            destination_id: this.state.destination_id,
            type: this.state.type,
            title: this.state.title,
            content: this.state.content,
        };
        //Handle check request
        axios.post('/api/mails/check-request', dataMail).then(response => {
            if (response.data.hasOwnProperty('success') && response.data.success) {
                if (this.state.destination == 6 || this.state.destination == 7) {
                    axios.get('/api/mails/' + this.state.destination + '/' + this.state.destination_id).then(response => {
                        this.setState({
                            first_last_name: response.data.first_last_name,
                            email: response.data.email,
                        })
                    });
                }
                $('#confirmModal').modal('show');
            } else if (response.data.error) {
                toast.error(response.data.message)
            } else {
                Object.keys(response.data.errors).map((key, i) => {
                    if($.isArray(response.data.errors[key])){
                        response.data.errors[key].map((child, i) => {
                            toast.error(child)
                        })
                    } else {
                        toast.error(response.data.errors[key])
                    }
                })
            }
        }).catch(error => {
            Object.keys(error.response.data.errors).map((key, i) => {
                if($.isArray(error.response.data.errors[key])){
                    error.response.data.errors[key].map((child, i) => {
                        toast.error(child)
                    })
                } else {
                    toast.error(error.response.data.errors[key])
                }
            })
        })
    }
    
    processDestinationName(destination) {
        switch(parseInt(destination)) {
            case 1:
                return '全シェアジョブ ユーザー(承認者のみ)';
            case 2:
                return '全ワーカー(承認者のみ)';
            case 3:
                return '全依頼者(承認者のみ)';
            case 4:
                return '全依頼者・法人(承認者のみ)';
            case 5:
                return 'テストメール配信(エントリーのみ)';
            case 6:
                return '依頼者個別配信';
            case 7:
                return 'ワーカー個別配信';
            default:
                return destination;
        }
    }
    
    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }
    
    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/mails">メール配信一覧</a></li>
                                <li className="breadcrumb-item active" aria-current="page">メール配信登録</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main">
                    <div className="row justify-content-md-center">
                        <div className="col-sm-6">
                            <div className="card mb-3">
                                <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">メール配信登録</h4></div>
                                    <div className="card-body">
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">宛先</label>
                                            <div className="col-sm-8">
                                                <ConstElement onElementChange={this.handleDestinationChange} element ="mails.destination" value={this.state.destination ? this.state.destination : ''} />
                                            </div>
                                        </div>
                                        { this.state.destination == 6 ?
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">依頼者ID</label>
                                            <div className="col-sm-8">
                                                <input type="text" name='destination_id' onChange={this.handleFieldChange} className="form-control" />
                                            </div>
                                        </div>
                                        : '' }
                                        { this.state.destination == 7 ?
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">ワーカーID</label>
                                            <div className="col-sm-8">
                                                <input type="text" name='destination_id' onChange={this.handleFieldChange} className="form-control" />
                                            </div>
                                        </div>
                                        : '' }
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">配信</label>
                                            <div className="col-sm-8">
                                                <ConstElement onElementChange={this.handleFieldChange} element ="mails.type" value={this.state.type ? this.state.type : ''} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">タイトル</label>
                                            <div className="col-sm-8">
                                                <input type="text" name='title' onChange={this.handleFieldChange} className="form-control" />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">内容</label>
                                            <div className="col-sm-8">
                                                <textarea name='content' onChange={this.handleFieldChange} className="form-control" rows="8"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                <div className="card-footer text-center">
                                    <button onClick={this.confirmCreateMail} className="btn btn-primary btn-radius btn-lg"><span className="size-inherit">登録する</span></button>
                                </div>
                                <div className="modal fade" id="confirmModal" tabIndex="-1" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content cover-loading-parent">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">メール配信を確認</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="form-group row">
                                                <div className="col-sm-4">宛先</div>
                                                <div className="col-sm-8">
                                                {this.processDestinationName(this.state.destination)}
                                                </div>
                                            </div>
                                            {this.state.destination == 6 || this.state.destination == 7 ?
                                            <div className="form-group row">
                                            <div className="col-sm-4"></div>
                                                <div className="col-sm-8">
                                                {this.state.destination == 6 ? <span className="badge bg-pink text-white">依頼者</span> : <span className="badge bg-purple text-white">ワーカー</span>} {this.state.first_last_name ? this.state.first_last_name : ''} { this.state.email ? " ("+this.state.email+")" : ''}
                                                </div>
                                            </div>
                                            : '' }
                                            <div className="form-group row">
                                                <label className="col-sm-4">タイトル</label>
                                                <div className="col-sm-8">{this.state.title ? this.state.title : ''}</div>
                                            </div>
                                        </div>
                                        <div className="card-footer text-center">
                                            <button type="button" className="btn btn-secondary clearfix" data-dismiss="modal">キャンセル</button>
                                            <button type="button" className="btn btn-primary" onClick={this.handleCreateMail}>登録する</button>
                                        </div>
                                        <div className="cover-loading block-hidden">処理中...</div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <ToastContainer />
            </React.Fragment>
        )
    }
}
